// extracted by mini-css-extract-plugin
module.exports = {"overlay":"src-components-ImpressumOverlay-styles__overlay--GS--i","container":"src-components-ImpressumOverlay-styles__container--165RX"};